import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload } from './utils'
// const API_ROOT = 'http://localhost:9014/api'
const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getPeriodicManagement = (projectCode, period) => {
  // /api/v1/accounting/period-manage/{projectCode}/{period}
  const url = `${API_ROOT_VER}/period-manage/${projectCode}/${period}`
  return doGet(url)
}

export const savePeriodicManagement = (request, projectCode, period) => {
  // /api/v1/accounting/period-manage/{projectCode}/{period}
  const url = `${API_ROOT_VER}/period-manage/${projectCode}/${period}`
  return doPost(url, request)
}

export const downloadPeriodManageFile = (fileId) => {
  // /api/v1/accounting/download/period-manage/attachment/{fileId}
  const url = `${API_ROOT_VER}/download/period-manage/attachment/${fileId}`
  return doDownload(url)
}

export const downloadFinancialCertifiedReportFile = (projectCode, periodNo) => {
  const url = `${API_ROOT}/files/download/${projectCode}/financial-certified-report/${periodNo}`
  return doDownload(url)
}

export const downloadFinancialCertifiedReportChecklistFile = (projectCode, periodNo) => {
  const url = `${API_ROOT}/files/download/${projectCode}/financial-certified-report-checklist/${periodNo}`
  return doDownload(url)
}
